import { ActivityFilterKey } from '@gripp/shared-logic';
import {
  ActivityList,
  SlideAction,
  SlideLayout,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityFilters } from '../../activity/components/activityFilters';
import { useAssetRouting } from '../assetRouteContext';
import { isFromActivitiesOrAssetPage } from '../assetUtils';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetDetail = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();
  const { basePath } = useAssetRouting(assetId ?? '');

  if (!assetId) {
    return null;
  }

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={assetId} />,
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    onBackButtonPress: () => {
      navigate(basePath);
    },
    backButtonTransition: SlideAction.PREV,
    disableScroll: false,
  };

  const rightColumn = {
    title: 'activity.header.title',
    mainComponent: <RightColumn assetId={assetId} />,
    headerComponent: <ActivityFilters assetId={assetId} />,
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => {
      try {
        // Prefer navigating back when the previous entry looks like an
        // activities or assets page. `document.referrer` works for full-page
        // navigations; for SPA navigations we still fall back to checking
        // history index.
        const cameFromActivityOrAsset = isFromActivitiesOrAssetPage(document);

        if (cameFromActivityOrAsset && history?.state?.idx > 0) {
          navigate(-1);
          return;
        } else {
          navigate(`/assets/${assetId}`);
        }
      } catch (e) {
        navigate(`/assets/${assetId}`);
      }
    },
    backButtonTransition: SlideAction.PREV,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const RightColumn = ({ assetId }: { assetId: string }) => {
  const { onSlideChange } = useSlideLayout();
  const navigate = useNavigate();

  const onIssueSelected = async (issueId: string) => {
    await onSlideChange(SlideAction.NEXT);

    navigate(`/assets/${assetId}/activity/${issueId}`);
  };

  return (
    <ActivityList
      filterKey={ActivityFilterKey.AssetActivity}
      onIssueSelected={onIssueSelected}
      assetId={assetId}
      showAssetName={false}
      showImage={false}
      pageSize={50}
      showTopBar={false}
    />
  );
};
